export default __webpack_public_path__ + "static/media/wolf.5bddf5b7.svg";